// Dependencias generales
import React from "react";
import HeliasFooterDark from '../../img/dark-theme/fevergy-brand.svg'

// Función del router
const FooterHELIAS = () => {
  return (    

    <footer className="footer vertical center">
      <a href="https://fevergy.com/" target="_blank" rel="noopener noreferrer">       
        <picture>
          <source srcSet={HeliasFooterDark} media="(prefers-color-scheme: dark)"/>
          <img src={HeliasFooterDark} alt="FEVERGY" height="24"/>
        </picture>
      </a>
    </footer>

  )
}

export default FooterHELIAS